<template>
  <div class="mft-c-table--scroll">
    <table class="mft-c-table--scroll__table">
      <thead>
        <slot name="header"></slot>
      </thead>
      <tbody>
        <slot name="body"></slot>
      </tbody>
      <tfoot>
        <slot name="footer"></slot>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.mft-c-table--scroll {
  overflow-x: auto;
  &__table {
    thead {
      th {
        background: $colour-cactus-core-green;
        color: white;
        border: 1px solid $colour-cactus-bright-green;
        min-width: 200px;
        padding: 5px;
          text-align: center;
      }
    }

    tbody {
      tr {
        &:nth-child(odd) {
          background: $colour-nhs-pale-blue;
        }
        td {
          min-width: max-content;
          border: 1px solid $colour-cactus-bright-green;
          padding: 5px;
          text-align: center;
        }
      }
    }
  }
}
</style>
